module.exports = __webpack_public_path__ + "img/photo_w.e194f5d0.svg";